// extracted by mini-css-extract-plugin
export default {"club":"VMatchTimeline_club_g_bHZ","head":"VMatchTimeline_head_2VQrc","root":"VMatchTimeline_root_3kz-h","vs":"VMatchTimeline_vs_1d2fm"};